// extracted by mini-css-extract-plugin
export default {"link":"FooterLink_link__u0SeF","block":"FooterLink_block__I+xkM"};